import React from "react";
import "./css/Splash.css";
import Dummy from "./components/Splash-Dummy";

function Splash() {
  return (
    <div className="container">
      <div className="row">
        <Dummy />
      </div>
    </div>
  );
}

export default Splash;
